/**
 * Pull display label and raw id out of a foreign-key value emitted by the backend.
 *
 * Backend wire format for FK label rendering:
 *
 * {
 *   label: string
 *   id: string | number | null
 * }
 *
 * Returns `null` when the value does not match the structured FK-label shape.
 * Callers should fall back to rendering the raw value.
 */

export interface FkLabelParts {
  label: string
  id: string
}

export function extractFkLabel(value: unknown): FkLabelParts | null {
  if (!value || typeof value !== 'object') return null

  const maybe = value as {
    label?: unknown
    id?: unknown
  }

  if (typeof maybe.label !== 'string') return null
  if (maybe.id === null || maybe.id === undefined) return null

  return {
    label: maybe.label,
    id: String(maybe.id),
  }
}
